<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <v-card elevation=0>
            <v-img
              class="white--text"
              height="150px"
              contain
              src="/images/products/ebook-domestic-violence.jpg"
            >
            </v-img>
            <v-card-title class="justify-center text-center">
              <div>
                <span>eBook: How to best separate:</span>
                <h3 class="headline mb-2">Domestic Violence</h3>
                <div v-if="product.unlocked" class="text-md-center teal--text mb-0">Already purchased.</div>
                <h3 v-else class="headline text-md-center teal--text mb-0">{{product.cost}}</h3>
              </div>
            </v-card-title>
            <v-card-actions class="justify-center">
              <v-btn v-if="product.unlocked" color="teal" dark @click="downloadEbook">Download</v-btn>
              <v-btn v-else color="teal" dark @click="showAlert">Buy</v-btn>
            </v-card-actions>
          </v-card>
      </v-col>
      <v-col cols="8">
        <h1 class="headline">How to best separate: Domestic Violence</h1>
        <p>Most relationships have elements of domestic violence (DV), they simply vary in severity. DV often starts slowly and many people don’t realise they are victims until they learn what it is and stop making excuses for their spouse’s choices.</p>
        <p>This e-book highlights what DV is, the different forms that it takes and what it may look or sound like so that you can better label the experiences in your relationship. It shares tips and strategies for victims of domestic violence so that they can feel empowered. It highlights how you can document what is happening or has happened to you so that you can rely upon it as evidence when you need. Finally, it contains a generous list of contacts and organisations to support you leave your relationship and re-establish yourself.</p>
      </v-col>
    </v-row>
    <product-purchase-dialog
      :dialogVisible="dialogVisible"
      :test="product.test"
      :firstName="firstName"
      :lastName="lastName"
      :email="email"
      :productName="product.name"
      :amount="product.cost"
      :stripePriceId="product.stripePriceId"
      @input="didDismissDialog"
      :didCompletePurchase="didCompletePurchase"></product-purchase-dialog>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    productId: '278f91d5-4433-4272-af9c-5db635e873d8',
    dialogVisible: false,
    productImageURL: ''
  }),
  created () {
    this.$store.dispatch('products/view', this.productId)
  },
  computed: {
    product () {
      return this.$store.getters['products/loadedProduct']
    },
    loading () {
      return this.$store.getters.loading
    },
    firstName () {
      return this.$store.getters.user.firstName
    },
    lastName () {
      return this.$store.getters.user.lastName
    },
    email () {
      return this.$store.getters.user.email
    }
  },
  methods: {
    showAlert () {
      this.dialogVisible = true
    },
    didDismissDialog (value) {
      this.dialogVisible = false
    },
    didCompletePurchase (productId) {
      this.$store.dispatch('products/unlock', this.productId)
    },
    downloadEbook () {
      this.$store.dispatch('download/sign', this.product.downloadURL).then(protectedURL => {
        window.location = protectedURL
      })
    }
  }
}
</script>
